import React from "react";
import { Snackbar, Alert } from "@mui/material";

export default function SubscriptionAlert({
  alertInfo,
  severity,
  setAlertInfo,
  offset = 0,
}) {
  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setAlertInfo({
      ...alertInfo,
      isOpen: false,
    });
    localStorage.removeItem("subscription");
  };

  if (!alertInfo) return null;

  return (
    <Snackbar
      sx={{
        top: (theme) => theme.spacing(1),
        paddingRight: (theme) => theme.spacing(2),
      }}
      open={alertInfo.isOpen}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      onClose={handleClose}
      style={{ top: `${offset}px` }}
    >
      <Alert
        sx={{
          userSelect: "text",
          pointerEvents: "auto",
        }}
        severity={severity}
        onClose={handleClose}
      >
        {alertInfo.type === "expired" ? (
          <span style={{ userSelect: "text" }}>{alertInfo.message}</span>
        ) : (
          <span style={{ userSelect: "text" }}>
            <strong>{alertInfo.serviceName}</strong> limit reached. Your current
            plan allows <strong>{alertInfo.serviceValue}</strong>, but you
            currently have <strong>{alertInfo.currentCount}</strong>.
          </span>
        )}
      </Alert>
    </Snackbar>
  );
}